import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { ShipperInterfaceDetails } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShipperInterfaceDetailsService extends TmsWebBaseEditCreateService<
  ShipperInterfaceDetails,
  ShipperInterfaceDetails
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ShipperInterfaceDetail', $localize`Shipper Interface Details`, httpService, notificationService);
  }
}
